import { BuilderConfig } from '@/types/builder';

import RoomstayBlogHeroUseCases, { RoomstayBlogHeroUseCasesProps } from './roomstay-blog-use-case-hero';

export const RoomstayBlogHeroUseCasesBuilderConfig = {
    name: 'Hero Use Cases',
    inputs: [
        {
            name: 'heading',
            type: 'string',
        },
        {
            name: 'title',
            type: 'html',
        },
        {
            name: 'description',
            type: 'html',
        },
        {
            name: 'image',
            type: 'file',
        },
        {
            name: 'buttons',
            type: 'list',
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    defaultValue: '',
                },
                {
                    name: 'link',
                    type: 'string',
                    defaultValue: '',
                },
                {
                    name: 'sectionId',
                    type: 'string',
                    defaultValue: '',
                },
                {
                    name: 'type',
                    type: 'text',
                    enum: ['highty', 'secondary', 'primary'],
                    defaultValue: '',
                },
                {
                    name: 'size',
                    type: 'text',
                    enum: ['default', 'medium', 'small'],
                    defaultValue: '',
                },
                {
                    name: 'color',
                    type: 'text',
                    enum: ['white', 'black'],
                    defaultValue: '',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<RoomstayBlogHeroUseCasesProps> = {
    component: RoomstayBlogHeroUseCases,
    config: RoomstayBlogHeroUseCasesBuilderConfig,
};

export default builderConfig;
